const LOCAL_API_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '0.0.0.0']);

const isLocalApiUrl = (url) => {
  if (!url) return true;
  try {
    return LOCAL_API_HOSTS.has(new URL(url).hostname);
  } catch {
    return false;
  }
};

/**
 * API base URL for browser fetch calls.
 * In local development, returns '' so requests stay same-origin and the CRA
 * proxy forwards them to the backend — avoiding CORS entirely.
 */
export const getApiBaseUrl = () => {
  const configured = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const isBrowser = typeof window !== 'undefined';
  const isLocalHost =
    isBrowser &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1');

  // Prefer same-origin + CRA proxy whenever we are clearly on local frontend
  if (
    (process.env.NODE_ENV === 'development' || isLocalHost) &&
    isLocalApiUrl(configured || 'http://localhost:5000')
  ) {
    return '';
  }

  return configured || 'http://localhost:5000';
};

export const API_BASE_URL = getApiBaseUrl();
